module.exports = __webpack_public_path__ + "static/carousel-0-0462589b289c7bda733d6ed84e5626bb.png";